// This is just an example,
// so you can safely delete all default props below

export default {
    title: 'Bestillingen var vellykket',
    description: '<div>Takk for at du bestiller og reiser med Kolumbus.</div><div>Du vil snart få en e-post med billetten din.</div><h5>Ikke lukk denne siden enda.</h5><div>Sjekk først at du har fått eposten med billetten, sjekk også søppelpost mappen din.</div><div>Nedenfor har du mulighet for å laste ned billetten som en ekstra mulighet.</div>',
    download: 'Last ned billett'
}
